import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/MainPages/LoginPage.vue'
import LandingPage from '../views/MainPages/LandingPage.vue'
import Organization from '../views/ChildPages/Organization.vue'
import Administration from '../views/ChildPages/Administration.vue'
import Category from '../views/ChildPages/Category.vue'
import Templates from '../views/ChildPages/Templates.vue'
import Medication from '../views/ChildPages/Medication.vue'
import Announcement from '../views/ChildPages/Announcement.vue'
import Checklist from '../views/ChildPages/Checklist.vue'
import LicenseSettings from '../views/ChildPages/LicenseSettings.vue'
import Masters from '@/views/ChildPages/Masters.vue'
import AuditLogs from '@/views/ChildPages/AuditLogs.vue'
import Testimonials from '@/views/ChildPages/Testimonials.vue'
import BlogPost from '@/views/ChildPages/BlogPost.vue'
import UserGuide from '@/views/ChildPages/UserGuide.vue'
// import ReleaseNotes from '@/views/ChildPages/ReleaseNotes.vue'
// import knowledgeBase from '@/views/ChildPages/knowledgeBase.vue'
import DrugLibrary from '@/views/ChildPages/DrugLibrary.vue'
import Labs from '@/views/ChildPages/LabsPage.vue'
import RCSSupportCases from '@/components/RCSSupport/Cases.vue'
import RCSSupportKnowledge from '@/components/RCSSupport/Knowledge.vue'
import RCSSupportAgents from '@/components/RCSSupport/SupportAgents.vue'
import RCSSupportSettings from '@/components/RCSSupport/Settings.vue'
import SupportModuleList from '@/components/SupportModule/ListModule.vue'
const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/landing',
    name: 'LandingPage',
    component: LandingPage,
    redirect: '/landing/organization',
    children: [
      {
        path: 'organization',
        name: 'Organization',
        component: Organization
      },
      {
        path: 'administration',
        name: 'Administration',
        component: Administration
      },
      {
        path: 'category',
        name: 'Category',
        component: Category
      },
      {
        path: 'templates',
        name: 'Templates',
        component: Templates
      },
      {
        path: 'medication',
        name: 'Medication',
        component: Medication
      },
      {
        path: 'masters',
        name: 'Masters',
        component: Masters
      },
      {
        path: 'announcement',
        name: 'Announcement',
        component: Announcement
      },
      {
        path: 'checklist',
        name: 'Checklist',
        component: Checklist
      },
      {
        path: 'licenseSettings',
        name: 'LicenseSettings',
        component: LicenseSettings
      },
      {
        path: 'labs',
        name: 'Labs',
        component: Labs
      },
      {
        path: 'auditLogs',
        name: 'AuditLogs',
        component: AuditLogs
      },
      {
        path: 'testimonials',
        name: 'Testimonials',
        component: Testimonials
      },
      {
        path: 'blogPost',
        name: 'BlogPost',
        component: BlogPost
      },
      {
        path:'UserGuide',
        name:'UserGuide',
        component:UserGuide
      },
      // {
      //   path: 'releaseNotes',
      //   name: 'ReleaseNotes',
      //   component: ReleaseNotes
      // },
      // {
      //   path:'knowledgeBase',
      //   name:'knowledgeBase',
      //   component:knowledgeBase
      // },
      {
        path: 'drugLibrary',
        name: 'DrugLibrary',
        component: DrugLibrary
      },
      {
        path: 'rcs-support/cases',
        name: 'RCSSupportCases',
        component: RCSSupportCases
      },
      {
        path: 'rcs-support/knowledge',
        name: 'RCSSupportKnowledge',
        component: RCSSupportKnowledge
      },
      {
        path: 'rcs-support/support-agents',
        name: 'RCSSupportAgents',
        component: RCSSupportAgents
      },
      {
        path: 'rcs-support/support-modules',
        name: 'RCSSupportModules',
        component: SupportModuleList
      },
      {
        path: 'rcs-support/settings',
        name: 'RCSSupportSettings',
        component: RCSSupportSettings
      },
    ]
  },
  {
    path: '/dashboard',
    redirect: '/landing/organization'
  },
  {
    path: '/organization',
    redirect: '/landing/organization'
  },
  {
    path: '/administration',
    redirect: '/landing/administration'
  },
  {
    path: '/category',
    redirect: '/landing/category'
  },
  {
    path: '/templates',
    redirect: '/landing/templates'
  },
  {
    path: '/medication',
    redirect: '/landing/medication'
  },
  {
    path: '/masters',
    redirect: '/landing/masters'
  },

  {
    path: '/announcement',
    redirect: '/landing/announcement'
  },
  {
    path: '/checklist',
    redirect: '/landing/checklist'
  },
  {
    path: '/licenseSettings',
    redirect: '/landing/licenseSettings'
  },
  // {
  //   path: '/releaseNotes',
  //   redirect: '/landing/releaseNotes'
  // },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

